import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Testimonial.css";
import { baseUrl } from "../UrlHelper/baseUrl";

const Testimonial = () => {
  const [reviews, setReviews] = useState([]);

useEffect(() => {
  const fetchReviews = async () => {
    try {
      const res = await axios.get(`${baseUrl}/user-review`);
      if (res.data.success) {
        setReviews(res.data.data); // ✅ reviews come from `data`
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };
  fetchReviews();
}, []);
  return (
    <section className="testimonial-web-section" id="testimonials">
      <div className="testimonial-web-container">
        <h2 className="testimonial-web-title">
          Our customers tell it better than we do!
        </h2>

        {reviews.length > 0 ? (
          <Swiper
            modules={[Pagination, Autoplay]}
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            autoplay={{ delay: 3000 }}
            pagination={{ clickable: true }}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="testimonial-web-wrapper"
          >
            {reviews.map((review, index) => (
              <SwiperSlide key={index} className="testimonial-web-items">
                {/* ⭐ Render stars based on rating */}
                <div className="testimonial-web-stars">
                  {"★".repeat(review.rating) +
                    "☆".repeat(5 - review.rating)}
                </div>
                <h3 className="testimonial-web-title fs-6">{review.title}</h3>
                <p className="testimonial-web-text">{review.message}</p>
                <h3 className="testimonial-web-title fs-6">{review.reviewer}</h3>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <p className="text-gray-500 mt-4">No reviews yet. Be the first!</p>
        )}
      </div>
    </section>
  );
};

export default Testimonial;
